import React, {useEffect} from 'react'
import {FullPageLoader} from 'attendee/theme/FullPageLoader'
import {useParams} from 'react-router-dom'
import {affiliateStorageKey} from 'organization/AffiliateProgram'
import {routes} from 'routes/routes'
import Cookies from 'js-cookie'
import {useLocalizedNavigate} from 'i18n/useLocalizedNavigate'

export function AffiliateReceiver() {
  const {affiliateToken} = useParams<{affiliateToken: string}>()
  const navigate = useLocalizedNavigate()

  useEffect(() => {
    if (!affiliateToken) return
    Cookies.set(affiliateStorageKey, affiliateToken, {expires: 30, path: '/'})
    navigate(routes.organization.login, {replace: true})
  }, [affiliateToken, navigate])

  return <FullPageLoader />
}
